import axiosInstance from "./AxiosInstance";
import axios from "axios";

const SERVICE_BASE_URLS = {
  thinkService: process.env.REACT_APP_THINK_SERVICE_URL,
  taxSkillService: process.env.REACT_APP_THINK_LANGCHAIN_SERVICE_URL,
};

// TaxSkill Service Instance
export const taxSkillApi = axios.create({
  ...axiosInstance.defaults,
  baseURL: SERVICE_BASE_URLS.taxSkillService,
});

if (!SERVICE_BASE_URLS.taxSkillService) {
  // Helpful warning during development so requests don't fall back to the FE origin
  // and return 404 (http://localhost:3000/<path>)
  // Set REACT_APP_TAXSKILL_SERVICE_URL, e.g. http://localhost:8000/api/v1
  // eslint-disable-next-line no-console
  console.warn(
    "REACT_APP_TAXSKILL_SERVICE_URL is not set; TaxSkill requests will 404 at the frontend origin."
  );
}

// Think Service reuses the shared axiosInstance (inherits interceptors)
axiosInstance.defaults.baseURL = SERVICE_BASE_URLS.thinkService;
export const thinkApi = axiosInstance;


